import { lazy, memo } from 'react';
import useTrigger from 'hooks/business/useTrigger';

const CashButton = lazy(() => import('./CashButton'));
const PayDlg = lazy(() => import('./PayDlg'));
const LeftBarButton = lazy(() => import('./LeftBarButton'));

const InviteButton = ({ type }: { type: 'LeftBar' | 'TopBar' | 'PayDlg' }) => {
  const { tickle, tiggered } = useTrigger('INVITE_BUTTON_CLICK');

  if (type === 'LeftBar') {
    return <LeftBarButton tickle={tickle} tiggered={tiggered} />;
  }

  if (type === 'PayDlg') {
    return <PayDlg tickle={tickle} />;
  }

  return <CashButton tickle={tickle} />;
};

export default memo(InviteButton);
